import Companies from "../pages/filters/Companies.vue";

export default [
    {
        name: 'home',
        path: '/',
    },
    {
        name: 'companies',
        path: '/equipes-artistiques',
        component: Companies,
    },
]
